var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"kl-icon",class:{ border: _vm.border },staticStyle:{"display":"inline-block"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"iconfont",class:_vm.icon,style:({ 'font-size': _vm.size + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }